// eslint-disable-next-line
// @ts-nocheck
import { itemType as itemTypeMetadata } from 'metadata';
import { cuiMethods } from 'cui';
import type MainWindowCuiLayout from '../../mainWindowCuiLayout/MainWindowCuiLayout';
import { getResource } from 'core';

let deepLinkingResolve;

const changeMessage = (frame) => {
	const win = frame.contentWindow;
	const msg = win.document.getElementById('message');
	if (!msg) {
		frame.addEventListener('load', function () {
			const msg = win.document.getElementById('message');
			msg.textContent = deepLinking.currentMsg;
		});
	} else {
		msg.textContent = deepLinking.currentMsg;
	}
};

const setDeepLinkingMessage = (msg) => {
	deepLinking.currentMsg = msg;
	const deepWindowIframe = document.getElementById('deepLinking');
	deepWindowIframe.style.display = 'block';
	document.getElementById('dimmer_spinner').classList.add('aras-hide');
	if (!deepWindowIframe.src) {
		deepWindowIframe.src = 'deepLinking.aspx';
	}
	changeMessage(deepWindowIframe);

	if (deepLinkingResolve) {
		deepLinkingResolve({
			startItemHandled: true
		});
	}
};

const deepLinkingStorageListener = (storageEvent) => {
	const storage = deepLinking.getStorage();

	if (
		storageEvent.key === 'DeepLinkingMainMenu' &&
		storageEvent.newValue === 'opening'
	) {
		storage.removeItem('DeepLinkingMainMenu');
		setDeepLinkingMessage(getResource('deep_link.start_opening_item'));
	}

	if (
		storageEvent.key === 'DeepLinkingResultOpenItem' &&
		storageEvent.newValue
	) {
		storage.removeItem('DeepLinkingResultOpenItem');
		storage.removeItem('DeepLinkingOpenStartItem');
		setDeepLinkingMessage(storageEvent.newValue);
		window.removeEventListener('storage', deepLinkingStorageListener);
	}
};

const openItem = async (
	itemTypeName: string,
	itemId: string,
	version: string
) => {
	const mainLayout: MainWindowCuiLayout = window.mainLayout;
	const cuiControl = mainLayout.navigationPanel.nav;
	const cuiOptions = mainLayout.options;
	const itemTypeId = itemTypeMetadata.getItemTypeId(itemTypeName);
	const itemToOpen = {
		itemTypeId,
		itemId,
		version
	};

	try {
		return await cuiMethods.openItemHandler(cuiControl, cuiOptions, itemToOpen);
	} catch (e) {
		return;
	}
};

const mainWindowListener = async (storageEvent) => {
	if (
		storageEvent.key !== 'DeepLinkingOpenStartItem' ||
		!storageEvent.newValue
	) {
		return;
	}

	const item = JSON.parse(storageEvent.newValue);
	const { itemTypeName, itemId, version = 'exact' } = item;

	if (
		!itemTypeName ||
		!itemId ||
		!aras.getLoginName ||
		aras.getLoginName() === ''
	) {
		return;
	}

	const storage = deepLinking.getStorage();
	storage.removeItem('DeepLinkingOpenStartItem');
	storage.removeItem('DeepLinkingResultOpenItem');
	storage.removeItem('DeepLinkingMainMenu');
	storage.setItem('DeepLinkingMainMenu', 'opening');

	const resultOpenItem = await openItem(itemTypeName, itemId, version);
	let message;
	if (resultOpenItem) {
		message = getResource(
			'deep_link.item_is_opened',
			itemTypeName + ' ' + aras.getKeyedName(itemId, itemTypeName)
		);
	} else {
		message = getResource('deep_link.error_open_item');
	}
	storage.setItem('DeepLinkingResultOpenItem', message);
};

const getStartItem = () => {
	const searchParams = new URLSearchParams(window.location.search);
	const startItemStr = searchParams.get('StartItem');
	const [type, itemId, version] = startItemStr?.split(':') || [];
	if (!type || !itemId) {
		return null;
	}

	const itemTypeName = type === 'inbasket' ? 'InBasket Task' : type;

	return {
		itemTypeName,
		itemId,
		version
	};
};

const deepLinking = {
	/* Constant that determines what time DeepLinkingWindow may look MainWindow*/
	SEARCH_TIME_THE_MAIN_WINDOW: 2000,
	currentMsg: '',
	onSuccessfulLogin() {
		window.addEventListener('storage', mainWindowListener);
		window.removeEventListener('storage', deepLinkingStorageListener);
	},
	async beforeInitializeLoginForm() {
		const storage = this.getStorage();

		window.addEventListener('beforeunload', function () {
			storage.removeItem('DeepLinkingOpenStartItem');
			storage.removeItem('DeepLinkingResultOpenItem');
			storage.removeItem('DeepLinkingMainMenu');
		});

		const startItem = getStartItem();
		if (!startItem) {
			return {
				startItemHandled: false
			};
		}

		window.addEventListener('storage', deepLinkingStorageListener);
		storage.removeItem('DeepLinkingOpenStartItem');
		storage.setItem('DeepLinkingOpenStartItem', JSON.stringify(startItem));

		return new Promise((resolve) => {
			deepLinkingResolve = resolve;
			setTimeout(() => {
				if (this.currentMsg === '') {
					window.removeEventListener('storage', deepLinkingStorageListener);
					resolve({
						startItemHandled: false
					});
				}

				resolve({
					startItemHandled: true
				});
			}, this.SEARCH_TIME_THE_MAIN_WINDOW);
		});
	},
	getStorage() {
		return window.localStorage;
	}
};

export default deepLinking;
